import { useRef, useEffect } from 'react';

import { usePathname, useSearchParams } from 'src/routes/hooks';

import { trackEvent, trackPageView } from 'src/utils/google-tag-manager';

import { getConfig } from 'src/global-config';

let appInitializedEventSent = false;

export function SpaAnalyticsListener() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    if (appInitializedEventSent) {
      return;
    }
    appInitializedEventSent = true;

    const CONFIG = getConfig();
    trackEvent('app_initialized', {
      app_name: CONFIG.appName,
      app_version: CONFIG.appVersion,
      app_mode: CONFIG.appMode,
    });
  }, []);

  useEffect(() => {
    const qs = searchParams.toString();
    const fullPath = qs ? `${pathname}?${qs}` : pathname;

    if (lastTrackedPath.current === fullPath) {
      return;
    }
    lastTrackedPath.current = fullPath;

    trackPageView(fullPath);
  }, [pathname, searchParams]);

  return null;
}
